import { render, staticRenderFns } from "./wechatLogin.vue?vue&type=template&id=062c8572"
import script from "./wechatLogin.vue?vue&type=script&lang=js"
export * from "./wechatLogin.vue?vue&type=script&lang=js"
import style0 from "./wechatLogin.vue?vue&type=style&index=0&id=062c8572&prod&lang=less&rel=stylesheet%2Fless"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports